import React from 'react';

import { MEDIA_TYPE } from 'constants/MediaConstants';
import FileTypeIcon from 'ui/base/MediaGallery/components/Medias/FileTypeIcon';
import { getExtension } from 'utils/fileName';

import { StyledThumbnail } from './UI';

const IMAGE_TYPES = [MEDIA_TYPE.IMAGE, MEDIA_TYPE.IMAGE_INSIDE_360];

/** @typedef {{media: import('modules/mediaLibrary/types').UploadModalMedia}} ThumbnailProps */
const Thumbnail = ({ media }) => {
  const type = media.mediaType || media.type;
  const extension = getExtension(media.filename);
  const thumbnail = media.thumbnailPath || media.path;

  const useImageViewer = Boolean(thumbnail && IMAGE_TYPES.includes(type));
  const showFileIcon = !useImageViewer && type !== MEDIA_TYPE.VIDEO;

  return (
    <StyledThumbnail className="thumbnail" background={useImageViewer ? thumbnail : undefined}>
      {showFileIcon && <FileTypeIcon height="50" width="50" extension={extension} type="file" />}
      {type === MEDIA_TYPE.VIDEO && (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video className="w-100 h-100">
          <source src={media.path} />
        </video>
      )}
    </StyledThumbnail>
  );
};

export default Thumbnail;
